import React from 'react';

const AboutPage = () => {
  return (
    <main className="legal-page"> {/* Using same classes as terms/privacy for consistency */}
      <div className="container">
        <div className="legal-content">
          <h1>About GTO Preflop</h1>
          
          <div className="legal-section">
            <h2>What is GTO Preflop?</h2>
            <p>GTO Preflop is a powerful mobile app designed to help poker players master preflop strategy using Game Theory Optimal (GTO) solutions. Whether you're a beginner looking to improve your fundamentals or an advanced player refining your strategy, GTO Preflop provides the tools you need to make mathematically sound decisions.</p>
          </div>

          <div className="legal-section">
            <h2>Key Features</h2>
            <ul>
              <li>Comprehensive preflop ranges based on GTO solutions</li>
              <li>Interactive training modules to test your knowledge</li>
              <li>Detailed hand analysis and explanations</li>
              <li>Support for various game formats and stack depths</li>
              <li>Regular updates with new content and features</li>
              <li>Offline access to all ranges once downloaded</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>Our Approach</h2>
            <p>At Peka Software, we believe that understanding the "why" behind each decision is as important as knowing the correct play. GTO Preflop doesn't just tell you what to do—it helps you understand the mathematical reasoning behind optimal poker strategy.</p>
            <p><strong>Our core philosophy is to create the easiest-to-use poker training app on the market.</strong> We strive for an experience that is super easy to use on the surface, yet extremely powerful behind the curtains. Looking up ranges and studying preflop needs to be a frictionless experience, and we are relentless in our pursuit of perfection in this regard.</p>
            <p>To deliver on this, we operate full-time dedicated, custom-built computers, specifically specced with high-end CPUs and RAM. These machines run 24/7, constantly solving preflop simulations. This allows us to continuously update GTO Preflop with new, accurate solutions, ensuring you always have access to the latest GTO strategies.</p>
            <p>Our ranges are developed using these advanced poker solvers and are continually refined by our team of poker professionals to ensure accuracy and relevance in today's games.</p>
          </div>

          <div className="legal-section">
            <h2>About the Developer</h2>
            <p>GTO Preflop was developed by Peka Software, founded by Petter Kårstad, a poker enthusiast and software developer with a passion for game theory and poker strategy. What began as a personal tool to improve his own game has evolved into a suite of poker apps used by thousands of players worldwide.</p>
          </div>

          <div className="legal-section">
            <h2>Our Other Apps</h2>
            <p>Check out our other poker training applications:</p>
            <ul>
              <li>
                <a href="https://apps.apple.com/za/app/gto-pocket-trainer/id6448717874" className="main-ios-trainer-link" target="_blank" rel="noopener noreferrer">GTO Pocket Trainer</a>
                <span className="android-link-container" style={{ display: 'none' }}> 
                  - <a href="https://play.google.com/store/apps/details?id=com.gtopre.gto_pocket_trainer" className="main-android-trainer-link" target="_blank" rel="noopener noreferrer">Android version</a>
                </span> - Interactive hand trainer for improving postflop play
              </li>
              <li>
                <a href="https://apps.apple.com/us/app/mystery-bounty-poker-solver/id6677032655" className="main-ios-bounty-link" target="_blank" rel="noopener noreferrer">Mystery Bounty Solver</a>
                <span className="android-link-container" style={{ display: 'none' }}> 
                  - <a href="https://play.google.com/store/apps/details?id=com.pekasoftware.mystery_bounty_poker_solver" className="main-android-bounty-link" target="_blank" rel="noopener noreferrer">Android version</a>
                </span> - Specialized tool for optimal strategy in Mystery Bounty tournaments
              </li>
              {/* Note: The original HTML had a script to dynamically show/hide Android links. This logic will need to be reimplemented in React if desired, or simplified. For now, the spans are kept with display:none. */}
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AboutPage; 